import React from 'react';
import { Layout, Menu } from 'antd';
import { DashboardIcon, PaymentIcon, UsersIcon } from '../Icon';
import Logo from '../../assets/images/showit-logo.png';
import { useHistory, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const Sidebar = ({collapsed, setCheckbox}: any) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <Sider className="sidebar" trigger={null} collapsible collapsed={collapsed}>
      <div className="sidebar-logo">
        <img className="logo" src={Logo} alt="Showit" />
      </div>
      <Menu theme="dark" mode="inline" defaultSelectedKeys={[location.pathname]}>
        <Menu.Item key="/" icon={<DashboardIcon />} onClick={() => history.push('/')}>
          Dashboard
        </Menu.Item>
        <Menu.Item key="/users" icon={<UsersIcon />} onClick={() => {
          setCheckbox([false, true]);
          history.push('users')
        }}>
          Users
        </Menu.Item>
        <Menu.Item key="/payments" icon={<PaymentIcon />} onClick={() => {
          setCheckbox([false, true]);
          history.push('payments')
        }}>
          Payments
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
